import { Skeleton, SkeletonProps } from '@material-ui/lab';
import { FC } from 'react';
import { COLORS } from 'shared/constants/COLORS';

const SkeletonStyle = {
  borderRadius: '10px',
  border: `1px solid ${COLORS.PRIMARY}`,
};

const AvatarSkeleton = (props: SkeletonProps) => {
  return (
    <Skeleton
      variant="rect"
      style={{
        ...SkeletonStyle,
        ...props.style,
      }}
    />
  );
};

export default AvatarSkeleton;
